/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()

  return (
    <>
      <style>{`
        #kt_footer {
          background: var(--bs-body-bg, #fff);
          border-top: 1px solid var(--bs-border-color, #e4e6ef);
        }
        html[data-theme-mode='dark'] #kt_footer {
          background: #1e1e2d;
          border-top: 1px solid #2d2d43;
        }
        .footer-copyright {
          font-size: 13px;
          color: var(--bs-gray-500, #a1a5b7);
        }
        .footer-copyright a {
          font-weight: 600;
          color: var(--bs-gray-700, #5e6278);
          text-decoration: none;
          transition: color .15s;
        }
        .footer-copyright a:hover { color: var(--theme-primary, #009ef7); }
        html[data-theme-mode='dark'] .footer-copyright { color: #565674; }
        html[data-theme-mode='dark'] .footer-copyright a { color: #92929f; }

        .footer-nav { display: flex; gap: 4px; list-style: none; margin: 0; padding: 0; }
        .footer-nav a {
          font-size: 13px; font-weight: 500; padding: 4px 10px; border-radius: 6px;
          color: var(--bs-gray-600, #7e8299);
          text-decoration: none;
          transition: color .15s, background .15s;
        }
        .footer-nav a:hover {
          color: var(--theme-primary, #009ef7);
          background: var(--theme-primary-light, #f1faff);
        }
        html[data-theme-mode='dark'] .footer-nav a { color: #565674; }
        html[data-theme-mode='dark'] .footer-nav a:hover {
          background: rgba(var(--theme-primary-rgb, 0,158,247), .12);
          color: var(--theme-primary, #009ef7);
        }
      `}</style>

      <div className='footer py-6 d-flex flex-lg-column' id='kt_footer'>
        <div className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}>

          <div className='footer-copyright order-2 order-md-1'>
            <span className='me-1'>{new Date().getFullYear()} &copy;</span>
            <a href='https://www.wisnet.com.tr' rel='noreferrer' target='_blank'>
              Wisnet
            </a>
          </div>

          <ul className='footer-nav order-1'>
            <li><a href='#'>About</a></li>
            <li><a href='#'>Contact</a></li>
          </ul>

        </div>
      </div>
    </>
  )
}

export { Footer }